// The console's demo view (A7U7), owned by hand: the live demos, the day's figures, purge and delete; behind
// `platform.demo.manage`, which the server checks (`/me` lists only granted powers, not a role's defaults).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { ConsoleDemo } from '../../features/platform/ConsoleDemo'
import { demoConsoleQuery } from '../../features/platform/queries'
import '../../features/platform/strings'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/platform/demo')({
  staticData: { screenId: 'ConsoleDemoScreen', access: 'platform.demo.manage' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(demoConsoleQuery()),
  component: ConsoleDemoScreen,
})

function ConsoleDemoScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.consoleDemo.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('platform.demo.title')} />
      <Part testId={ids.consoleDemo.skeleton}>
        <ConsoleDemo />
      </Part>
    </main>
  )
}
